<div class="countdown-wrap {{type}}" *ngIf="timerStr" [innerHTML]="timerStr"> </div>